import { ValidationError } from "sequelize"
import {
    MarkovTransition,
    MarkovTransitionCreate,
    MarkovTransitionSave,
} from "server/models"
import { OrderType } from "client/utils"
import { GET, POST, DELETE, sort, validate } from "client/store/utils"
import { LangType, MarkovExpressionParseVars } from "client/store"
import {
    MarkovTransitionList,
    MarkovTransitionValidation,
} from "./types"


export const LoadAllMarkovTransitions = (modelId: number) => (
    GET(`/markovTransition/modelId/${modelId}`)
    .then((transitions: MarkovTransition[]) => {
        const transitionList: MarkovTransitionList = {}
        transitions.forEach((transition) => {
            transitionList[transition.id] = transition
        })
        return transitionList
    })
)

export const LoadMarkovTransitionById = (transitionId: number, modelId: number) => (
    GET(`/markovTransition/id/${transitionId}/modelId/${modelId}`)
    .then((transition: MarkovTransition) => transition)
)

export const GetMarkovTransitionVariableUsage = (variableId: number) => {
    const variableIndex = `var_${variableId}`
    return GET(`/markovTransition/variableUsage/${variableIndex}`)
    .then((transitions: MarkovTransition[]) => {
        const transitionExpressions: MarkovTransition[] = []
        transitions.forEach((transition) => {
            const variablesParsed = MarkovExpressionParseVars(transition.expression)
            const variablesEqual = variablesParsed.find((row) => row === variableIndex)
            if (variablesEqual && variablesEqual.length) transitionExpressions.push(transition)
        })
        return transitionExpressions
    })
}

export const SaveMarkovTransition = (
    id: number,
    transition: MarkovTransitionCreate,
    lang: LangType,
) => {
    const data: MarkovTransitionSave = {
        id,
        transition,
    }
    return POST(
        "/markovTransition/save",
        JSON.stringify(data),
    ).then((res) => {
        const newTransition = res as MarkovTransition
        const error = res as ValidationError

        return {
            newTransitionId: newTransition.id || null,
            validation: <MarkovTransitionValidation>validate(error, lang),
        }
    })
}

export const DeleteMarkovTransition = (transitionId: number, modelId: number) => (
    DELETE(`/markovTransition/delete/${transitionId}/${modelId}`)
    .then((removedRows: number) => removedRows)
)

export const SortMarkovTransitions = (
    transitions: MarkovTransition[],
    sortColumn: keyof MarkovTransition,
    sortOrder: OrderType,
) => {
    transitions.sort((a, b) => sort(a, b, sortColumn, sortOrder))
    const transitionIds: number[] = []
    transitions.forEach((transition) => transitionIds.push(transition.id))

    return transitionIds
}
